<div
  data-testid="multi-file-upload-container"
  class="multi-file-upload-container"
>
  <!-- Upload Controls Section -->
  <div class="upload-controls">
    <!-- Drag and Drop Zone -->
    <div
      data-testid="multi-file-upload-dropzone"
      class="drag-drop-zone"
      [class.drag-over]="isDragOver()"
      [class.disabled]="disabled || !canUploadMore()"
      (dragover)="onDragOver($event)"
      (dragleave)="onDragLeave($event)"
      (drop)="onDrop($event)"
      [attr.aria-label]="'common.form.placeholders.drag_drop_files' | translate"
    >
      <div class="drag-drop-content">
        <!-- Control Buttons Section -->
        <div class="control-buttons">
          <button
            data-testid="multi-file-upload-choose-btn"
            type="button"
            class="choose-btn"
            [disabled]="disabled || !canUploadMore()"
            (click)="onChooseFiles()"
            [title]="'common.buttons.choose_files' | translate"
          >
            {{ "material.form.upload.choose" | translate }}
          </button>

          <button
            data-testid="multi-file-upload-cancel-btn"
            type="button"
            class="cancel-btn"
            [disabled]="disabled"
            (click)="onCancelUpload()"
            [title]="'common.buttons.cancel' | translate"
          >
            {{ "material.form.upload.cancel" | translate }}
          </button>
        </div>

        <!-- Upload Info -->
        <div data-testid="multi-file-upload-info" class="upload-info">
          <span class="info-text">
            {{ "material.form.upload.max_size" | translate }}:
            {{ formatFileSize(dynamicMaxSize()) }} |
            {{ "material.form.upload.accepted_types" | translate }}:
            {{ getAcceptedFormatsText() }} |
            {{ "material.form.upload.files_count" | translate }}:
            {{ allImages().length }}/{{ maxFiles }}
          </span>
        </div>

        <!-- Drag Text -->
        <div data-testid="multi-file-upload-drag-text" class="drag-text-section">
          <span class="drag-text">
            {{ "material.form.upload.drag_drop" | translate }}
          </span>
        </div>
      </div>
    </div>
  </div>

  <!-- File List Section -->
  @if (allImages().length > 0) {
  <div data-testid="multi-file-upload-file-list-container" class="file-list-container">
    <div
      data-testid="multi-file-upload-file-list"
      class="file-list"
      [class.scrollable]="hasMoreFiles()"
      cdkDropList
      (cdkDropListDropped)="onReorderDrop($event)"
    >
      @for (file of allImages(); track file.id || file.fileName) {
      <div
        [attr.data-testid]="
          'multi-file-upload-file-item-' + (file.id || file.fileName)
        "
        class="file-item"
        cdkDrag
        [cdkDragDisabled]="!reorderable || disabled"
        [class.file-item-reorderable]="reorderable && !disabled"
      >
        <!-- File Thumbnail -->
        <div
          [attr.data-testid]="
            'multi-file-upload-file-thumbnail-' + (file.id || file.fileName)
          "
          class="file-thumbnail"
        >
          @if (file.previewUrl) {
          <img
            [attr.data-testid]="
              'multi-file-upload-file-preview-' + (file.id || file.fileName)
            "
            [src]="file.previewUrl"
            [alt]="file.fileName"
            class="thumbnail-image"
            draggable="false"
          />
          } @else {
          <i
            [attr.data-testid]="
              'multi-file-upload-file-icon-' + (file.id || file.fileName)
            "
            class="pi pi-file file-icon"
          ></i>
          }
        </div>

        <!-- File Information -->
        <div
          [attr.data-testid]="
            'multi-file-upload-file-details-' + (file.id || file.fileName)
          "
          class="file-details"
        >
          <div
            [attr.data-testid]="
              'multi-file-upload-file-name-' + (file.id || file.fileName)
            "
            class="file-name"
            [title]="file.fileName"
          >
            {{ file.fileName }}
          </div>
          <div class="file-info-row">
            <div
              [attr.data-testid]="
                'multi-file-upload-file-size-' + (file.id || file.fileName)
              "
              class="file-size"
            >
              {{ formatFileSize(file.fileSize || 0) }}
            </div>
            @if (getFileStatusClass(file) === 'new') {
            <div
              [attr.data-testid]="
                'multi-file-upload-file-status-' + (file.id || file.fileName)
              "
              class="file-status-tag"
              [ngClass]="getFileStatusClass(file)"
            >
              {{ getFileStatusText(file) }}
            </div>
            }
          </div>
        </div>

        <!-- Delete Button -->
        @if (!disabled) {
        <button
          [attr.data-testid]="
            'multi-file-upload-delete-btn-' + (file.id || file.fileName)
          "
          type="button"
          class="delete-btn"
          (click)="removeFile(file)"
          [title]="'common.buttons.remove_file' | translate"
        >
          ×
        </button>
        }
      </div>
      }
    </div>
  </div>
  }

  <!-- Hidden File Input -->
  <input
    #fileInput
    data-testid="multi-file-upload-input"
    type="file"
    [multiple]="true"
    [accept]="dynamicAccept()"
    [disabled]="disabled"
    (change)="onFileInputChange($event)"
    style="display: none"
  />
</div>

<p-toast data-testid="multi-file-upload-toast"></p-toast>
